import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const RowIconTitleCaptionButtonSectionItem = (
  { imageSrc, header, body, linkUrl, linkText, linkCustomClasses, headerClasses, bodyClasses   }) => {
  // const brandSlug = window.gon.current_brand ? window.gon.current_brand : 'shipsticks';

  return (
    <div className="h-full flex flex-col">
      {imageSrc &&
        <img src={imageSrc} alt={header} className="py-2 h-20 self-start" />
      }

      <div className="text-left flex flex-col flex-grow">
        <h3 className={`font-semibold text-xl ${headerClasses || ''}`}>{parse(header)}</h3>
        <div className={`text-[#231F20] mt-2 ${bodyClasses || ''}`}>{parse(body)}</div>
        {linkUrl && linkText &&
          <div className="mt-auto pt-4">
            <a
              href={linkUrl}
              className={`inline-block px-6 py-2 font-medium rounded
              ${linkCustomClasses || ''}`}
            >
              {linkText}
            </a>
          </div>
        }
      </div>
    </div>
  );
};

RowIconTitleCaptionButtonSectionItem.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  headerClasses: PropTypes.string,
  body: PropTypes.string.isRequired,
  bodyClasses: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  linkCustomClasses: PropTypes.string,
};

export default RowIconTitleCaptionButtonSectionItem;
